import React, { PureComponent } from 'react'
import { PropTypes } from 'prop-types'
import { Link } from 'react-router-dom'
import config from 'config'
// import { get } from 'lodash'

// import { apiConfiguration } from 'helpers/decorators/api'
// import { CONFIGURATION_KEYS } from 'constants/enums'
import logoImg from 'assets/img/dofe-logo.png'

// @apiConfiguration()
export default class Logo extends PureComponent {
  static propTypes = {
    className: PropTypes.string
    // configuration: PropTypes.object.isRequired,
    // onGetConfigurationValue: PropTypes.func.isRequired
  }
  static defaultProps = {
    className: ''
  }

  // componentDidMount = () =>
  //   this.props.onGetConfigurationValue(CONFIGURATION_KEYS.aboutAwardUrl.id)

  render() {
    const { className } = this.props
    // const aboutAwardUrl = get(
    //   configuration,
    //   `values[${CONFIGURATION_KEYS.aboutAwardUrl.id}].textValue`
    // )

    const LogoElement = (
      <img
        className={className}
        src={logoImg}
        alt="Dukes of Edinburgh logo"
        width="150"
        height="42"
      />
    )

    return <Link to={`${config.publicPath}/`}>{LogoElement}</Link>
  }
}
